export default __webpack_public_path__ + "static/media/arrow-up.2a24bd76.svg";